import { createSlice } from "@reduxjs/toolkit";
import Api from "../../../lib/api";

export const adminName = "adminUsers";

const initialState = {
    adminUsers: {},
};

const adminsSlice = createSlice({
    name: adminName,
    initialState,
    reducers: {
        getAdminUser: (state, { payload }) => {
            const { entities } = payload;
            state.adminUsers = entities.adminUsers;
        },
    },
});

export const { getAdminUser } = adminsSlice.actions;
export default adminsSlice.reducer;

export const adminSelectors = () => (state) => state[adminName].adminUsers;

export const initUsers = () => async (dispatch) => {
    try {
        const response = await Api.get("admin-users", { params: { "page[size]": 50 } });

        await dispatch(getAdminUser({ ...response }));
    } catch (error) {
        console.log(error);
    }
};
